import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * Card com seção expansível "Mostrar detalhes" — v5
 * Toggle usa Raleway (herda do Layout, mas garantimos explicitamente)
 */

const FONT_BODY = "'Raleway', -apple-system, sans-serif";
const ACCENT = '#50cfad';

export default function ExpandableCard({
  children,
  expandedContent,
  expandable = true,
  defaultExpanded = false
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const hasExpandableContent = expandedContent || typeof children === 'function';
  const showToggle = expandable && hasExpandableContent;

  return (
    <div style={{
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(12px)',
      borderRadius: '1rem',
      overflow: 'hidden',
      marginBottom: '1.5rem',
      fontFamily: FONT_BODY
    }}>
      {/* Conteúdo principal */}
      <div style={{ padding: '1.25rem' }}>
        {typeof children === 'function' ? children(isExpanded) : children}
      </div>

      {/* Conteúdo expandido fixo (modo legado) */}
      {isExpanded && expandedContent && (
        <div style={{
          padding: '0.75rem 1.25rem 1.25rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          {expandedContent}
        </div>
      )}

      {/* Botão toggle */}
      {showToggle && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            width: '100%',
            padding: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: FONT_BODY
          }}
        >
          <span style={{
            fontFamily: FONT_BODY,
            fontSize: '0.875rem',
            fontWeight: 600,
            color: ACCENT
          }}>
            {isExpanded ? 'Ocultar detalhes' : 'Mostrar detalhes'}
          </span>
          {isExpanded ? (
            <ChevronUp size={16} color={ACCENT} strokeWidth={2.5} />
          ) : (
            <ChevronDown size={16} color={ACCENT} strokeWidth={2.5} />
          )}
        </button>
      )}
    </div>
  );
}
